// Shared types for administration services
export interface OperationMode {
    id: string;
    name: string;
    description: string;
}

export interface PaginatedItems<T = any> {
    items: T[];
    total: number;
}

export interface ApkListResponse {
    data: any[];
    pagination: {
        totalCount: number;
    };
}

export interface SensorCamera {
    id: string;
    name: string;
    lines: string[];
    zones: string[];
}

export interface RfidTagFilter {
    id: string;
    filter: string;
}

export interface RfidTag {
    id: string;
    product: {
        name: string;
    } | null;
}

export interface FastlanerTrolleyItem {
    groupName: string;
    groupId: string;
    expectedAppVersions: string[];
}

export interface LogicConfiguration {
    timeStamp?: string;
}

export interface MediaPlayerTemplate {
    id: string;
    name: string;
    configuration: {
        defaultWelcome: string;
        defaultTitle: string;
        defaultFirstName: string;
        defaultLastName: string;
        alternateLine1: string;
        alternateLine2: string;
        alternateLine3: string;
        alternateLine4: string;
    };
}

export interface NotificationTemplate {
    id?: string;
    name: string;
    subject: string;
    body: string;
    incidentType?: IncidentTypes;
    createDate?: string;
    recipientsForAllShops?: string[];
    recipientWithShops?: RecipientWithShops[];
    isActiveOnStoreOperationModes: string[];
    isDefault?: boolean;
}

export interface RecipientWithShops {
    eMail: string;
    shopIds: string[];
}

export enum IncidentTypes {
    BarrierManipulation = 'BarrierManipulation',
    CrawlAlarm = 'CrawlAlarm',
    DeviceOffline = 'DeviceOffline',
    DeviceOnline = 'DeviceOnline',
    DoorClosed = 'DoorClosed',
    DoorOpened = 'DoorOpened',
    EmergencyButtonPressed = 'EmergencyButtonPressed',
    ExternalDoorStuckOpen = 'ExternalDoorStuckOpen',
    GateOpenedMainDirection = 'GateOpenedMainDirection',
    GateOpenedOppositeDirection = 'GateOpenedOppositeDirection',
    GeneralAlarm = 'GeneralAlarm',
    InvalidScan = 'InvalidScan',
    OperationModeChanged = 'OperationModeChanged',
    PanicAlarm = 'PanicAlarm',
    ReverseAlarm = 'ReverseAlarm',
    Tailgating = 'Tailgating',
    ValidScan = 'ValidScan'
}

export interface DuplicateRfidTag {
    id: string;
    productId: string;
}

export interface ComponentData {
    name: string;
    description: string;
    ipAddress: string;
    port: number;
    discriminator: string;
    shopId: string;
    gatewayId: string | null;
    lines: string[];
    zones: string[];
    txPowerInDbm: number;
    rxSensitivityInDbm: number;
    disabledAntennas: string[];
    type: string;
    resetTimeoutInMs: number;
    sensorCameraType: string;
    id?: string;
    deviceId?: string;
    deviceCid?: string;
    disabled?: boolean;
    fastLanerGroupIds?: string[];
    hybridLocStoreKey?: string;
}
